// extracted by mini-css-extract-plugin
module.exports = {"info":"_1RQ_LYV","hide":"_3n0d2rQ"};